import Chevron from 'src/components/dashboard/components/navigationMenu/components/chevron';
import Dropdown from './Form/Components/dropdownMenu/dropdownMenu';
import Spinner from 'src/components/ui/spinner';
import React, { useRef, useState } from 'react';

interface IProps {
    users: any;
    isLoading: boolean;
    setSelectedUser: Function;
    selectedUser: any;
}

const FieldUserList: React.FC<IProps> = ({
    users,
    isLoading,
    selectedUser,
    setSelectedUser,
}) => {
    const ref: any = useRef(null);
    const [open, setOpen] = useState<boolean>(true);
    const [setRotate, setRotateState] = useState<string>(
        'accordion__icon rotate',
    );

    return (
        <div
            className='userDropdownWrapper'
            ref={ref}
            onClick={() => {
                ref.current.focus();
                setOpen(!open);
                setRotateState(
                    open
                        ? 'accordion__icon rotate'
                        : 'accordion__icon rotate-270',
                );
            }}
        >
            <div className='labelWrapper'>
                {!!selectedUser?.name ? selectedUser.name : 'Select User'}
                <span>
                    <Chevron
                        className={`${setRotate}`}
                        width={16}
                        fill={'#777'}
                    />
                </span>
            </div>
            {isLoading ? (
                <div className='loader_container'>
                    <Spinner />
                </div>
            ) : (
                <Dropdown
                    open={open}
                    submenus={users}
                    refEle={ref}
                    handlerChange={(value: boolean) => {
                        setOpen(value);
                        setRotateState(
                            !value
                                ? 'accordion__icon rotate'
                                : 'accordion__icon rotate-270',
                        );
                    }}
                    handlerItemChange={(val: any) => {
                        setSelectedUser(val);
                    }}
                    showSelected={true}
                    defaultSelected={
                        !!selectedUser?.name
                            ? selectedUser.name
                            : 'Search list...'
                    }
                    showSelectedIcon={true}
                    right={'0'}
                    isDealership={false}
                    showSearch
                    shouldUseModal={false}
                />
            )}
        </div>
    );
};

export default FieldUserList;
